import React from 'react';

import { Milestone } from 'models/shipments/Payload';
import { getFutureMilestones, showEdd } from 'utils/milestone.utils';

import { useCurrentArticle } from '../../hooks/shipment.hooks';
import CurrentMilestone from '../CurrentMilestone/CurrentMilestone';
import DisruptionNotices from '../DisruptionNotices/DisruptionNotices';
import FutureMilestones from '../FutureMilestones/FutureMilestones';
import { useJourneyMilestones } from '../hooks/TrackingPanel.hooks';
import PastMilestones from '../PastMilestones/PastMilestones';
import { JOURNEY_VIEW_TEST_ID } from './JourneyView.test-ids';

import styles from './JourneyView.module.scss';

const JourneyView: React.FC = () => {
  const milestones = useJourneyMilestones();
  const addressType = useCurrentArticle()?.address?.addressType || null;

  let currentMilestone, pastMilestones;
  if (milestones.length === 1) {
    currentMilestone = milestones[0];
  } else if (milestones.length > 1) {
    pastMilestones = milestones.slice(0, -1);
    currentMilestone = milestones.slice(-1)[0];
  } else {
    return null;
  }
  const { milestone, events } = currentMilestone;
  const futureMilestone = getFutureMilestones(milestone, addressType);
  const greenTramTracks = milestone === Milestone.DELIVERED;

  return (
    <div
      id='JourneyTabPanel'
      className={styles.journeyView}
      role='tabpanel'
      aria-labelledby='OptionJourney'
      tabIndex={0}
      data-testid={JOURNEY_VIEW_TEST_ID}
    >
      <DisruptionNotices />
      {pastMilestones && <PastMilestones milestones={pastMilestones} isDelivered={greenTramTracks} />}
      <CurrentMilestone milestone={milestone} events={events} hasNext={!!futureMilestone?.length} />
      {!!futureMilestone?.length && (
        <>
          <div className={styles.divider} />
          <FutureMilestones milestones={futureMilestone} hasNext={showEdd(milestone)} />
        </>
      )}
    </div>
  );
};

export default JourneyView;
